import { useAuth } from './auth';
import { AdminInMiniApp, AuthError, Loading, NoTelegram } from './screens/Screens';
import { CourierApp } from './screens/CourierApp';
import { ClientApp } from './screens/ClientApp';

/**
 * Выбор интерфейса по роли. Роль приходит с сервера и перечитывается им из БД
 * при каждом запросе — здесь она используется только для отрисовки.
 * Настоящая проверка прав живёт на каждом эндпоинте.
 */
export function App() {
  const { state, refresh } = useAuth();

  switch (state.status) {
    case 'loading':
      return <Loading />;
    case 'no-telegram':
      return <NoTelegram />;
    case 'error':
      return <AuthError message={state.message} onRetry={() => void refresh()} />;
    case 'ready':
      switch (state.user.role) {
        case 'courier':
          // Курьер ведёт свои экраны сам — у него своя история переходов
          return <CourierApp user={state.user} />;
        case 'admin':
          return <AdminInMiniApp />;
        default:
          return <ClientApp user={state.user} />;
      }
  }
}
